export default {
  errorFrom400to500: 'Что-то пошло не так! Попробуйте еще раз.',
  errorReqRes: 'Пожалуйста, попробуйте позже.',
  nonexistentFotobook: 'Пожалуйста, сделайте выбор!',
  tooMuchFoto: 'Слишком много фотографий!',
  tooLessFoto: 'Слишком мало фотографий!',
  tooMuchCover: 'Слишком много обложек!',
  orderStatusError: 'Что-то пошло не так! Попробуйте еще раз.',
  linkPay: 'Пожалуйста, перейдите по ссылке для оплаты!',
  checkPromocode: 'Промокод получен.',
  notCurier: 'Пожалуйста, выбрите тип доставки!',
  promoError: 'Промокод не найден!',
  orderAccepted: 'Ваш заказ принят!',
  infoToMail: 'Информация о заказе была отправлена на email ',
};
